<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="card-items">
      <component v-for="product in products" :allowResourceSelection="true" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="product.id" :is="getProductComponent(product)" :product="product.product" :productShopId="product.shopid" :displayName="displayName">
        {{ product.name }}
      </component>
    </div>
  </div>
</template>

<script>

import components from '~/lib/components'
/*
import BuyableProductListItem from '~/components/BuyableProductListItem'
import ReservableProductListItem from '~/components/ReservableProductListItem'
import ContentProductListItem from '~/components/ContentProductListItem'
import InvalidProductListItem from '~/components/InvalidProductListItem'
*/
import products from '~/lib/products'
import constants from '~/lib/constants'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      categoryId: null,
      products: []
    }
  },
  mixins: [components, products, constants],
  computed: {
    data () {
      return JSON.parse(this.component.data)
    },
    displayName () {
      return this.data && this.data.displayName ? this.data.displayName : ''
    }
  },
  methods: {
    getProductComponent (product) {
      if (!product.product) {
        return resolveComponent('InvalidProductListItem')
      }
      switch (product.type) {
        case '0':
          if (product.product.sharedResourcepool && product.product.sharedResourcepool.length) { // Product variations require a popup
            return resolveComponent('ReservableProductListItem')
          }
          if (product.product.minprice || product.product.maxprice) { // Custom-priced value cards also require a popup
            return resolveComponent('ReservableProductListItem')
          }
          if (parseInt(product.subtype,10) === 8) {
            return resolveComponent('ContentProductListItem')
          }
          return resolveComponent('BuyableProductListItem')
        default:
          return resolveComponent('ReservableProductListItem')
      }
    },
    parseProducts() {
      this.products = this.products.filter((product) => parseInt(product?.subtype, 10) !== this.SUBTYPE_TICKET && !parseInt(product?.deleted, 10) && !parseInt(product?.archived, 10))
      if (this.data && this.data.displayName === 'product') { // Let's re-sort the products by name since they will be sorted by displayedname
        this.products.sort((a, b) => a.product.name.localeCompare(b.product.name))
      }
    }
  },
  updated () {
    if (this.categoryId !== this.data.categoryId) {
      this.loadProducts(this.parseProducts)
    }
  },
  mounted () {
    this.loadProducts(this.parseProducts)
    if(!this.events) {
      let events = {}
      events['categoryUpdate'] = debounce((message) => {
        if (message.shopId === this.shopId && message.data.id == this.data.categoryId) {
          this.loadProducts(this.parseProducts)
        }
      }, 200)
      events['productUpdate'] = debounce((message) => {
        for (var i = 0; i < this.products.length; i++) {
          let product = this.products[i]
          if (product.shopid == message.shopId && product.source_id == message.data.id) {
            this.loadProduct(product.shopid, product.source_id)
          }
        }
      }, 200)
      events['availabilityUpdate'] = debounce((message) => {
        for (var i = 0; i < this.products.length; i++) {
          let product = this.products[i]
          if (product.shopid == message.shopId && message.data && message.data.affectedProducts && message.data.affectedProducts.indexOf(parseInt(product.source_id, 10)) !== -1) {
            this.loadProduct(product.shopid, product.source_id)
          }
        }
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>
<style>
.fa-shopping-basket:before {
    content: "\f291";
}
</style>

